
import { Component, Mixins } from 'vue-property-decorator';
import { AthleteRoutingMixin, VuetifyMixin, BAIconsMixin } from '@/mixins';

@Component
export default class UpgradeNowButton extends Mixins(VuetifyMixin, AthleteRoutingMixin, BAIconsMixin){
}
